import { render } from "./InviteFriend.vue?vue&type=template&id=03c87225"
import script from "./InviteFriend.vue?vue&type=script&lang=js"
export * from "./InviteFriend.vue?vue&type=script&lang=js"

import "./InviteFriend.vue?vue&type=style&index=0&id=03c87225&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__